export default __webpack_public_path__ + "static/media/hospital-bed.9b6c3bf2.png";